//Redux types

//Auth
export const INITIALIZE_AUTH = "INITIALIZE_AUTH";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const CLEAR_PROFILE = "CLEAR_PROFILE";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const CLEAR_FEED = "CLEAR_FEED";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const DELETE_ACCOUNT_ERROR = "DELETE_ACCOUNT_ERROR";
export const UPDATE_REQUESTS = "UPDATE_REQUESTS";
export const TOKEN_REFRESH_SUCCESS = "TOKEN_REFRESH_SUCCESS";
export const TOKEN_REFRESH_FAIL = "TOKEN_REFRESH_FAIL";
export const SHOW_REGISTER_MODAL = "SHOW_REGISTER_MODAL";
export const HIDE_REGISTER_MODAL = "HIDE_REGISTER_MODAL";
export const SHOW_LOGIN_MODAL = "SHOW_LOGIN_MODAL";
export const HIDE_LOGIN_MODAL = "HIDE_LOGIN_MODAL";
export const SET_TOKENS_FROM_CALLBACK = "SET_TOKENS_FROM_CALLBACK";

//Signup
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const SET_SIGNUP_STAGE = "SET_SIGNUP_STAGE";
export const CLEAR_SIGNUP = "CLEAR_SIGNUP";
export const SET_REGISTER_ERRORS = "SET_REGISTER_ERRORS";
export const SIGNUP_RESTRICTIONS_NEXT = "SIGNUP_RESTRICTIONS_NEXT";
export const SIGNUP_RESTRICTIONS_ERROR = "SIGNUP_RESTRICTIONS_ERROR";
export const SIGNUP_PREFERENCES_NEXT = "SIGNUP_PREFERENCES_NEXT";
export const SIGNUP_PREFERENCES_ERROR = "SIGNUP_PREFERENCES_ERROR";
export const SIGNUP_ABILITY_NEXT = "SIGNUP_ABILITY_NEXT";
export const SIGNUP_ABILITY_ERROR = "SIGNUP_ABILITY_ERROR";

//Profile
export const SET_CURRENT_PROFILE = "SET_CURRENT_PROFILE";
export const CURRENT_PROFILE_ERROR = "CURRENT_PROFILE_ERROR";

export const GET_VIEWED_PROFILE = "GET_VIEWED_PROFILE";
export const MY_VIEWED_PROFILE = "MY_VIEWED_PROFILE";
export const VIEWED_PROFILE_ERROR = "VIEWED_PROFILE_ERROR";
export const RESET_VIEWED_PROFILE = "RESET_VIEWED_PROFILE";
export const GET_PROFILE_POSTDATA = "GET_PROFILE_POSTDATA";
export const GET_PROFILE_POST_ERROR = "GET_PROFILE_POST_ERROR";
export const GET_PROFILE_RECIPEDATA = "GET_PROFILE_RECIPEDATA";
export const GET_PROFILE_RECIPE_ERROR = "GET_PROFILE_RECIPE_ERROR";

//Edit Profile
export const UPDATE_EDIT_PROFILE = "UPDATE_EDIT_PROFILE";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";

//Feed
export const GET_HOME_FEED = "GET_HOME_FEED";
export const SET_HOME_FEED = "SET_HOME_FEED";
export const HOME_FEED_ERROR = "HOME_FEED_ERROR";
export const FETCH_FEED_POST = "FETCH_FEED_POST";
export const SET_FEED_POST = "SET_FEED_POST";
export const UPDATE_POST_CACHE_INTERACTIONS = "UPDATE_POST_CACHE_INTERACTIONS";
export const GET_FEED_POST_ERROR = "GET_FEED_POST_ERROR";
export const REMOVE_INVALID_POST = "REMOVE_INVALID_POST";
export const GET_POST_COMMENTS = "GET_POST_COMMENTS";
export const GET_POST_COMMENTS_ERROR = "GET_POST_COMMENTS_ERROR";
export const GET_POST_COMMENTS_RESET = "GET_POST_COMMENTS_RESET";
export const SET_POST_INTERACTIONS = "SET_POST_INTERACTIONS";
export const FEED_DELETE_COMMENT = "FEED_DELETE_COMMENT";
export const COMMENT_LIKE = "COMMENT_LIKE";
export const COMMENT_LIKE_ERROR = "COMMENT_LIKE_ERROR";
export const REFRESH_HOME_FEED = "REFRESH_HOME_FEED";

//Dual Feed System
export const SET_FEED_TYPE = "SET_FEED_TYPE";
export const GET_FOLLOWING_FEED = "GET_FOLLOWING_FEED";
export const GET_TRENDING_FEED = "GET_TRENDING_FEED";
export const REFRESH_FOLLOWING_FEED = "REFRESH_FOLLOWING_FEED";
export const REFRESH_TRENDING_FEED = "REFRESH_TRENDING_FEED";
export const SET_FOLLOWING_FEED = "SET_FOLLOWING_FEED";
export const SET_TRENDING_FEED = "SET_TRENDING_FEED";
export const FOLLOWING_FEED_ERROR = "FOLLOWING_FEED_ERROR";
export const TRENDING_FEED_ERROR = "TRENDING_FEED_ERROR";
//Create Recipe
export const RECIPE_CREATE_FORMAT_INGRED = "RECIPE_CREATE_FORMAT_INGRED";
export const RECIPE_CREATE_UPDATE = "RECIPE_CREATE_UPDATE";
export const RECIPE_CREATE_INGRED_ERROR = "RECIPE_CREATE_INGRED_ERROR";
export const RECIPE_CREATE_REMOVE_INGRED = "RECIPE_CREATE_REMOVE_INGRED";
export const RECIPE_CREATE_EDIT_INGRED = "RECIPE_CREATE_EDIT_INGRED";
export const GET_EDIT_RECIPE = "GET_EDIT_RECIPE";
export const GET_EXTERNAL_RECIPE = "GET_EXTERNAL_RECIPE";
export const GET_GENERATED_RECIPE = "GET_GENERATED_RECIPE";
export const RECIPE_CREATE_RESET = "RECIPE_CREATE_RESET";
export const TOGGLE_RECIPE_MACROS_MODAL = "TOGGLE_RECIPE_MACROS_MODAL";
export const TOGGLE_RECIPE_OUTPUT_MODAL = "TOGGLE_RECIPE_OUTPUT_MODAL";
export const TOGGLE_RECIPE_TIMING_MODAL = "TOGGLE_RECIPE_TIMING_MODAL";
export const SET_ORIGINAL_IMAGES = "SET_ORIGINAL_IMAGES";
export const SET_CREATE_RECIPE_ERRORS = "SET_CREATE_RECIPE_ERRORS";
export const RESET_CREATE_RECIPE_ERRORS = "RESET_CREATE_RECIPE_ERRORS";
export const CLEAR_CREATE_RECIPE_ERROR_PATH = "CLEAR_CREATE_RECIPE_ERROR_PATH";

//Create Recipe Modals
export const RECIPE_CREATE_OPEN_ADD_INGRED_MODAL = "RECIPE_CREATE_OPEN_ADD_INGRED_MODAL";
export const RECIPE_CREATE_CLOSE_ADD_INGRED_MODAL = "RECIPE_CREATE_CLOSE_ADD_INGRED_MODAL";
export const RECIPE_CREATE_OPEN_EDIT_INGRED_MODAL = "RECIPE_CREATE_OPEN_EDIT_INGRED_MODAL";
export const RECIPE_CREATE_CLOSE_EDIT_INGRED_MODAL = "RECIPE_CREATE_CLOSE_EDIT_INGRED_MODAL";
export const RECIPE_CREATE_OPEN_EDIT_STEP_MODAL = "RECIPE_CREATE_OPEN_EDIT_STEP_MODAL";
export const RECIPE_CREATE_CLOSE_EDIT_STEP_MODAL = "RECIPE_CREATE_CLOSE_EDIT_STEP_MODAL";

//Walkthrough
export const RESET_WALKTHROUGH = "RESET_WALKTHROUGH";
export const WALKTHROUGH_GET_RECIPE = "WALKTHROUGH_GET_RECIPE";
export const WALKTHROUGH_RECIPE_ERROR = "WALKTHROUGH_RECIPE_ERROR";
export const WALKTHROUGH_SET_SECTION = "WALKTHROUGH_SET_SECTION";
export const WALKTHROUGH_SET_INGREDIENT = "WALKTHROUGH_SET_INGREDIENT";
export const WALKTHROUGH_SCALE_RECIPE = "WALKTHROUGH_SCALE_RECIPE";
export const WALKTHROUGH_SCALE_SECTION = "WALKTHROUGH_SCALE_SECTION";
export const WALKTHROUGH_SET_SERVINGS_EATEN = "WALKTHROUGH_SET_SERVINGS_EATEN";
export const WALKTHROUGH_SET_SECTION_SERVINGS = "WALKTHROUGH_SET_SECTION_SERVINGS";
export const SET_WALKTHROUGH_ERRORS = "SET_WALKTHROUGH_ERRORS";
export const WALKTHROUGH_SHOW_MACROS_MODAL = "WALKTHROUGH_SHOW_MACROS_MODAL";
export const WALKTHROUGH_HIDE_MACROS_MODAL = "WALKTHROUGH_HIDE_MACROS_MODAL";
export const WALKTHROUGH_SET_MACROS_MODAL_SECTION = "WALKTHROUGH_SET_MACROS_MODAL_SECTION";
export const WALKTHROUGH_SET_INGREDIENT_MEASURED = "WALKTHROUGH_SET_INGREDIENT_MEASURED";

//Update
export const GET_NEW_UPDATES = "GET_NEW_UPDATES";
export const NEW_UPDATES_ERROR = "NEW_UPDATES_ERROR";
export const CLOSE_UPDATE_MODAL = "CLOSE_UPDATE_MODAL";

//Alert
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

//Pantry
export const PANTRY_RESET_STATE = "PANTRY_RESET_STATE";
export const PANTRY_LOCATIONS_REQUEST = "PANTRY_LOCATIONS_REQUEST";
export const PANTRY_LOCATIONS_SUCCESS = "PANTRY_LOCATIONS_SUCCESS";
export const PANTRY_LOCATIONS_FAIL = "PANTRY_LOCATIONS_FAIL";
export const PANTRY_OPEN_ITEM_MODAL = "PANTRY_OPEN_ITEM_MODAL";
export const PANTRY_CLOSE_ITEM_MODAL = "PANTRY_CLOSE_ITEM_MODAL";
export const PANTRY_ITEM_MODAL_LOADED = "PANTRY_ITEM_MODAL_LOADED";
export const PANTRY_ITEM_MODAL_ERROR = "PANTRY_ITEM_MODAL_ERROR";
export const PANTRY_SET_CREATE_DATA = "PANTRY_SET_CREATE_DATA";
export const PANTRY_SET_ITEM_MODAL_DATA = "PANTRY_SET_ITEM_MODAL_DATA";
export const PANTRY_OPEN_LOCATION_MODAL = "PANTRY_OPEN_LOCATION_MODAL";
export const PANTRY_CLOSE_LOCATION_MODAL = "PANTRY_CLOSE_LOCATION_MODAL";
export const PANTRY_LOCATION_MODAL_LOADING = "PANTRY_LOCATION_MODAL_LOADING";
export const PANTRY_LOCATION_MODAL_ERROR = "PANTRY_LOCATION_MODAL_ERROR";
export const PANTRY_SET_LOCATION_MODAL_DATA = "PANTRY_SET_LOCATION_MODAL_DATA";
export const PANTRY_OPEN_ADD_ITEM_MODAL = "PANTRY_OPEN_ADD_ITEM_MODAL";
export const PANTRY_CLOSE_ADD_ITEM_MODAL = "PANTRY_CLOSE_ADD_ITEM_MODAL";
export const PANTRY_SET_ADD_MODAL_VIEW = "PANTRY_SET_ADD_MODAL_VIEW";
export const PANTRY_CREATE_ADD_ONHAND_AMOUNT = "PANTRY_CREATE_ADD_ONHAND_AMOUNT";
export const PANTRY_CREATE_EDIT_ONHAND_AMOUNT = "PANTRY_CREATE_EDIT_ONHAND_AMOUNT";
export const PANTRY_CREATE_REMOVE_ONHAND_AMOUNT = "PANTRY_CREATE_REMOVE_ONHAND_AMOUNT";
export const PANTRY_CREATE_REORDER_ONHAND_AMOUNTS = "PANTRY_CREATE_REORDER_ONHAND_AMOUNTS";
export const PANTRY_CREATE_SET_LOCATION = "PANTRY_CREATE_SET_LOCATION";
export const PANTRY_CREATE_SET_DATES = "PANTRY_CREATE_SET_DATES";
export const PANTRY_CREATE_SET_BRAND = "PANTRY_CREATE_SET_BRAND";
export const PANTRY_CREATE_SET_PRODUCT = "PANTRY_CREATE_SET_PRODUCT";
export const PANTRY_CREATE_SET_STORE = "PANTRY_CREATE_SET_STORE";
export const PANTRY_CREATE_SET_EXPENSE = "PANTRY_CREATE_SET_EXPENSE";
export const PANTRY_CREATE_SET_PURCHASE = "PANTRY_CREATE_SET_PURCHASE";
export const PANTRY_CREATE_SINGLE_REQUEST = "PANTRY_CREATE_SINGLE_REQUEST";
export const PANTRY_CREATE_SINGLE_SUCCESS = "PANTRY_CREATE_SINGLE_SUCCESS";
export const PANTRY_CREATE_SINGLE_FAIL = "PANTRY_CREATE_SINGLE_FAIL";
export const PANTRY_LOCATION_ITEMS_REQUEST = "PANTRY_LOCATION_ITEMS_REQUEST";
export const PANTRY_LOCATION_ITEMS_SUCCESS = "PANTRY_LOCATION_ITEMS_SUCCESS";
export const PANTRY_LOCATION_ITEMS_FAIL = "PANTRY_LOCATION_ITEMS_FAIL";
export const PANTRY_LOCATION_ITEMS_APPEND = "PANTRY_LOCATION_ITEMS_APPEND";
export const PANTRY_LOCATION_ITEMS_SET_FILTERS = "PANTRY_LOCATION_ITEMS_SET_FILTERS";
export const PANTRY_LOCATION_ITEMS_SET_SEARCH = "PANTRY_LOCATION_ITEMS_SET_SEARCH";
export const PANTRY_LOCATION_ITEMS_RESET = "PANTRY_LOCATION_ITEMS_RESET";
export const PANTRY_REMOVE_SINGLE_REQUEST = "PANTRY_REMOVE_SINGLE_REQUEST";
export const PANTRY_REMOVE_SINGLE_SUCCESS = "PANTRY_REMOVE_SINGLE_SUCCESS";
export const PANTRY_REMOVE_SINGLE_FAIL = "PANTRY_REMOVE_SINGLE_FAIL";

//Pantry Item Modals
export const PANTRY_OPEN_REMOVE_ITEM_MODAL = "PANTRY_OPEN_REMOVE_ITEM_MODAL";
export const PANTRY_CLOSE_REMOVE_ITEM_MODAL = "PANTRY_CLOSE_REMOVE_ITEM_MODAL";
export const PANTRY_OPEN_MOVE_ITEM_MODAL = "PANTRY_OPEN_MOVE_ITEM_MODAL";
export const PANTRY_CLOSE_MOVE_ITEM_MODAL = "PANTRY_CLOSE_MOVE_ITEM_MODAL";
export const PANTRY_OPEN_EDIT_EXPENSE_MODAL = "PANTRY_OPEN_EDIT_EXPENSE_MODAL";
export const PANTRY_CLOSE_EDIT_EXPENSE_MODAL = "PANTRY_CLOSE_EDIT_EXPENSE_MODAL";
export const PANTRY_OPEN_EDIT_PRODUCT_MODAL = "PANTRY_OPEN_EDIT_PRODUCT_MODAL";
export const PANTRY_CLOSE_EDIT_PRODUCT_MODAL = "PANTRY_CLOSE_EDIT_PRODUCT_MODAL";
export const PANTRY_OPEN_EDIT_STORE_MODAL = "PANTRY_OPEN_EDIT_STORE_MODAL";
export const PANTRY_CLOSE_EDIT_STORE_MODAL = "PANTRY_CLOSE_EDIT_STORE_MODAL";
export const PANTRY_OPEN_EDIT_ONHAND_MODAL = "PANTRY_OPEN_EDIT_ONHAND_MODAL";
export const PANTRY_CLOSE_EDIT_ONHAND_MODAL = "PANTRY_CLOSE_EDIT_ONHAND_MODAL";
export const PANTRY_OPEN_EDIT_DATES_MODAL = "PANTRY_OPEN_EDIT_DATES_MODAL";
export const PANTRY_CLOSE_EDIT_DATES_MODAL = "PANTRY_CLOSE_EDIT_DATES_MODAL";

//Search
export const SEARCH_SET_QUERY = "SEARCH_SET_QUERY";
export const SEARCH_SET_TYPE = "SEARCH_SET_TYPE";
export const SEARCH_GET_RESULTS = "SEARCH_GET_RESULTS";
export const SEARCH_RESULTS_ERROR = "SEARCH_RESULTS_ERROR";
export const SEARCH_RESET_RESPONSE = "SEARCH_RESET_RESPONSE";
export const SEARCH_FETCH_PROFILES = "SEARCH_FETCH_PROFILES";
export const SEARCH_PROFILES_ERROR = "SEARCH_PROFILES_ERROR";

//Recipes
export const GET_RECIPE_FROM_URL = "GET_RECIPE_FROM_URL";
export const RECIPE_FROM_URL_ERROR = "RECIPE_FROM_URL_ERROR";
export const RESET_STANDALONE_RECIPE = "RESET_STANDALONE_RECIPE";
export const LIKE_RECIPE = "LIKE_RECIPE";
export const UNLIKE_RECIPE = "UNLIKE_RECIPE";
export const LIKE_RECIPE_ERROR = "LIKE_RECIPE_ERROR";
export const BOOKMARK_RECIPE = "BOOKMARK_RECIPE";
export const UNBOOKMARK_RECIPE = "UNBOOKMARK_RECIPE";
export const BOOKMARK_RECIPE_ERROR = "BOOKMARK_RECIPE_ERROR";
export const RECIPE_CREATED = "RECIPE_CREATED";
//Media
export const IMAGE_UPLOAD_ADD = "IMAGE_UPLOAD_ADD";
export const IMAGE_UPLOAD_REMOVE = "IMAGE_UPLOAD_REMOVE";
export const IMAGE_UPLOAD_ERROR = "IMAGE_UPLOAD_ERROR";
export const IMAGE_UPLOAD_RESET = "IMAGE_UPLOAD_RESET";
export const IMAGE_UPLOAD_CROP = "IMAGE_UPLOAD_CROP";
export const IMAGE_UPLOAD_CROP_ERROR = "IMAGE_UPLOAD_CROP_ERROR";
export const IMAGE_UPLOAD_REORDER = "IMAGE_UPLOAD_REORDER";
export const IMAGE_UPLOAD_OPEN_CROP = "IMAGE_UPLOAD_OPEN_CROP";
export const IMAGE_UPLOAD_CLOSE_CROP = "IMAGE_UPLOAD_CLOSE_CROP";

//Cookbook
export const GET_COOKBOOK_RECIPES = "GET_COOKBOOK_RECIPES";
export const COOKBOOK_RECIPES_ERROR = "COOKBOOK_RECIPES_ERROR";
export const GET_DEFAULT_RECIPE_FILTERS = "GET_DEFAULT_RECIPE_FILTERS";
export const GET_DEFAULT_RECIPE_FILTERS_ERROR = "GET_DEFAULT_RECIPE_FILTERS_ERROR";
export const SET_SEARCH_RECIPES = "SET_SEARCH_RECIPES";
export const GET_SEARCH_RECIPES = "GET_SEARCH_RECIPES";
export const SEARCH_RECIPES_ERROR = "SEARCH_RECIPES_ERROR";
export const RESET_COOKBOOK_FILTERS = "RESET_COOKBOOK_FILTERS";
export const SEARCH_RECIPES_RESET = "SEARCH_RECIPES_RESET";
export const SET_COOKBOOK_QUERY = "SET_COOKBOOK_QUERY";
export const RESET_COOKBOOK_QUERY = "RESET_COOKBOOK_QUERY";
export const SET_ALLERGEN_FILTERS = "SET_ALLERGEN_FILTERS";
export const SET_DIETARY_FILTERS = "SET_DIETARY_FILTERS";
export const SET_INCLUDE_FILTERS = "SET_INCLUDE_FILTERS";
export const SET_EXCLUDE_FILTERS = "SET_EXCLUDE_FILTERS";
export const SET_INCLUDE_INGRED_TYPE = "SET_INCLUDE_INGRED_TYPE";

//Reviews
export const SHOW_RECIPE_REVIEW_MODAL = "SHOW_RECIPE_REVIEW_MODAL";
export const HIDE_RECIPE_REVIEW_MODAL = "HIDE_RECIPE_REVIEW_MODAL";
export const CREATE_RECIPE_REVIEW = "CREATE_RECIPE_REVIEW";
export const CREATE_RECIPE_REVIEW_ERROR = "CREATE_RECIPE_REVIEW_ERROR";
export const FETCH_RECIPE_REVIEWS = "FETCH_RECIPE_REVIEWS";
export const FETCH_RECIPE_REVIEWS_ERROR = "FETCH_RECIPE_REVIEWS_ERROR";
export const RESET_RECIPE_REVIEWS = "RESET_RECIPE_REVIEWS";

//Notifications
export const GET_UNREAD_NOTIFICATIONS = "GET_UNREAD_NOTIFICATIONS";
export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const GET_ALL_NOTIFICATIONS_ERROR = "GET_ALL_NOTIFICATIONS_ERROR";
export const GET_UNREAD_NOTIFICATIONS_ERROR = "GET_UNREAD_NOTIFICATIONS_ERROR";
export const RESET_ALL_NOTIFICATIONS = "RESET_ALL_NOTIFICATIONS";
export const APPEND_NOTIFICATIONS = "APPEND_NOTIFICATIONS";
export const SET_HAS_MORE_NOTIFICATIONS = "SET_HAS_MORE_NOTIFICATIONS";
export const GET_NOTIFICATION_BY_ID = "GET_NOTIFICATION_BY_ID";
export const GET_NOTIFICATION_BY_ID_ERROR = "GET_NOTIFICATION_BY_ID_ERROR";

//Navigation
export const TOGGLE_CREATE_MODAL = "TOGGLE_CREATE_MODAL";
export const TOGGLE_KITCHEN_DASHBOARD_MODAL = "TOGGLE_KITCHEN_DASHBOARD_MODAL";
export const NAVIGATE = "NAVIGATE";
export const NAVIGATE_RESET = "NAVIGATE_RESET";

//Plus
export const TOGGLE_PLUS_UPGRADE_MODAL = "TOGGLE_PLUS_UPGRADE_MODAL";

//Device
export const GET_DEVICE_INFO = "GET_DEVICE_INFO";
export const DEVICE_INFO_ERROR = "DEVICE_INFO_ERROR";

//INSIGHTS
export const GET_MY_MACROS = "GET_MY_MACROS";
export const GET_MY_MACROS_ERROR = "GET_MY_MACROS_ERROR";
export const RESET_MACROS_DATA = "RESET_MACROS_DATA";
export const GET_SINGLE_MACRO = "GET_SINGLE_MACRO";
export const GET_SINGLE_MACRO_ERROR = "GET_SINGLE_MACRO_ERROR";
export const UPDATE_MACRO_EVENT_SERVINGS = "UPDATE_MACRO_EVENT_SERVINGS";
export const UPDATE_MACRO_EVENT_SERVINGS_ERROR = "UPDATE_MACRO_EVENT_SERVINGS_ERROR";
export const GET_RECIPE_HISTORY = "GET_RECIPE_HISTORY";
export const RECIPE_HISTORY_ERROR = "RECIPE_HISTORY_ERROR";
export const SET_RECIPE_HISTORY = "SET_RECIPE_HISTORY";
export const POST_MACRO_EVENT_SERVINGS = "POST_MACRO_EVENT_SERVINGS";
export const REMOVE_MACRO_EVENT = "REMOVE_MACRO_EVENT";
export const SET_MY_MACROS = "SET_MY_MACROS";
export const SET_SINGLE_MACRO = "SET_SINGLE_MACRO";

// QuickTrack
export const TOGGLE_QUICKTRACK_MODAL = "TOGGLE_QUICKTRACK_MODAL";
export const QUICKTRACK_CREATE_REQUEST = "QUICKTRACK_CREATE_REQUEST";
export const QUICKTRACK_CREATE_SUCCESS = "QUICKTRACK_CREATE_SUCCESS";
export const QUICKTRACK_CREATE_ERROR = "QUICKTRACK_CREATE_ERROR";
export const QUICKTRACK_SET_SERVINGS = "QUICKTRACK_SET_SERVINGS";
export const QUICKTRACK_TOGGLE_SERVINGS = "QUICKTRACK_TOGGLE_SERVINGS";
export const QUICKTRACK_ADD_ITEM = "QUICKTRACK_ADD_ITEM";
export const QUICKTRACK_UPDATE_ITEM = "QUICKTRACK_UPDATE_ITEM";
export const QUICKTRACK_REMOVE_ITEM = "QUICKTRACK_REMOVE_ITEM";
export const QUICKTRACK_OPEN_EDIT_MACRO_MODAL = "QUICKTRACK_OPEN_EDIT_MACRO_MODAL";
export const QUICKTRACK_CLOSE_EDIT_MACRO_MODAL = "QUICKTRACK_CLOSE_EDIT_MACRO_MODAL";
export const QUICKTRACK_SET_EDIT_INDEX = "QUICKTRACK_SET_EDIT_INDEX";
export const QUICKTRACK_SET_EDIT_PREFILL = "QUICKTRACK_SET_EDIT_PREFILL";
export const QUICKTRACK_OPEN_EDIT_SERVINGS_MODAL = "QUICKTRACK_OPEN_EDIT_SERVINGS_MODAL";
export const QUICKTRACK_CLOSE_EDIT_SERVINGS_MODAL = "QUICKTRACK_CLOSE_EDIT_SERVINGS_MODAL";
export const QUICKTRACK_RESET_STATE = "QUICKTRACK_RESET_STATE";
export const QUICKTRACK_SET_EVENT_NAME = "QUICKTRACK_SET_EVENT_NAME";
export const QUICKTRACK_SET_EVENT_DESCRIPTION = "QUICKTRACK_SET_EVENT_DESCRIPTION";
export const QUICKTRACK_ADD_SECTION = "QUICKTRACK_ADD_SECTION";
export const QUICKTRACK_UPDATE_SECTION = "QUICKTRACK_UPDATE_SECTION";
export const QUICKTRACK_REMOVE_SECTION = "QUICKTRACK_REMOVE_SECTION";
export const QUICKTRACK_ADD_SECTION_MACRO = "QUICKTRACK_ADD_SECTION_MACRO";
export const QUICKTRACK_UPDATE_SECTION_MACRO = "QUICKTRACK_UPDATE_SECTION_MACRO";
export const QUICKTRACK_REMOVE_SECTION_MACRO = "QUICKTRACK_REMOVE_SECTION_MACRO";
export const QUICKTRACK_ADD_SECTION_INGREDIENT_USED = "QUICKTRACK_ADD_SECTION_INGREDIENT_USED";
export const QUICKTRACK_UPDATE_SECTION_INGREDIENT_USED = "QUICKTRACK_UPDATE_SECTION_INGREDIENT_USED";
export const QUICKTRACK_REMOVE_SECTION_INGREDIENT_USED = "QUICKTRACK_REMOVE_SECTION_INGREDIENT_USED";
export const QUICKTRACK_ADD_SECTION_INGREDIENT_ADDED = "QUICKTRACK_ADD_SECTION_INGREDIENT_ADDED";
export const QUICKTRACK_UPDATE_SECTION_INGREDIENT_ADDED = "QUICKTRACK_UPDATE_SECTION_INGREDIENT_ADDED";
export const QUICKTRACK_REMOVE_SECTION_INGREDIENT_ADDED = "QUICKTRACK_REMOVE_SECTION_INGREDIENT_ADDED";
export const QUICKTRACK_SET_SECTION_SERVINGS = "QUICKTRACK_SET_SECTION_SERVINGS";
export const QUICKTRACK_SET_SECTION_NOTES = "QUICKTRACK_SET_SECTION_NOTES";
export const QUICKTRACK_ADD_IMAGE = "QUICKTRACK_ADD_IMAGE";
export const QUICKTRACK_REMOVE_IMAGE = "QUICKTRACK_REMOVE_IMAGE";
export const QUICKTRACK_SEARCH_REQUEST = "QUICKTRACK_SEARCH_REQUEST";
export const QUICKTRACK_SEARCH_SUCCESS = "QUICKTRACK_SEARCH_SUCCESS";
export const QUICKTRACK_SEARCH_ERROR = "QUICKTRACK_SEARCH_ERROR";
export const QUICKTRACK_PREFILL_FROM_SEARCH = "QUICKTRACK_PREFILL_FROM_SEARCH";
export const QUICKTRACK_CLEAR_SEARCH = "QUICKTRACK_CLEAR_SEARCH";
export const QUICKTRACK_OPEN_SECTION_MODAL = "QUICKTRACK_OPEN_SECTION_MODAL";
export const QUICKTRACK_CLOSE_SECTION_MODAL = "QUICKTRACK_CLOSE_SECTION_MODAL";

//Admin
export const ADMIN_DASHBOARD_LOADING = "ADMIN_DASHBOARD_LOADING";
export const ADMIN_DASHBOARD_SUCCESS = "ADMIN_DASHBOARD_SUCCESS";
export const ADMIN_DASHBOARD_ERROR = "ADMIN_DASHBOARD_ERROR";
export const ADMIN_INGREDIENTS_LOADING = "ADMIN_INGREDIENTS_LOADING";
export const ADMIN_INGREDIENTS_SUCCESS = "ADMIN_INGREDIENTS_SUCCESS";
export const ADMIN_INGREDIENTS_ERROR = "ADMIN_INGREDIENTS_ERROR";
export const ADMIN_INGREDIENT_LOADING = "ADMIN_INGREDIENT_LOADING";
export const ADMIN_INGREDIENT_SUCCESS = "ADMIN_INGREDIENT_SUCCESS";
export const ADMIN_INGREDIENT_ERROR = "ADMIN_INGREDIENT_ERROR";
export const ADMIN_INGREDIENT_UPDATE_LOADING = "ADMIN_INGREDIENT_UPDATE_LOADING";
export const ADMIN_INGREDIENT_UPDATE_SUCCESS = "ADMIN_INGREDIENT_UPDATE_SUCCESS";
export const ADMIN_INGREDIENT_UPDATE_ERROR = "ADMIN_INGREDIENT_UPDATE_ERROR";
export const ADMIN_SUGGESTIONS_LOADING = "ADMIN_SUGGESTIONS_LOADING";
export const ADMIN_SUGGESTIONS_SUCCESS = "ADMIN_SUGGESTIONS_SUCCESS";
export const ADMIN_SUGGESTIONS_ERROR = "ADMIN_SUGGESTIONS_ERROR";
export const ADMIN_SUGGESTION_REVIEW_LOADING = "ADMIN_SUGGESTION_REVIEW_LOADING";
export const ADMIN_SUGGESTION_REVIEW_SUCCESS = "ADMIN_SUGGESTION_REVIEW_SUCCESS";
export const ADMIN_SUGGESTION_REVIEW_ERROR = "ADMIN_SUGGESTION_REVIEW_ERROR";

//Document Edits
export const DOCUMENT_EDITS_LOADING = "DOCUMENT_EDITS_LOADING";
export const DOCUMENT_EDITS_SUCCESS = "DOCUMENT_EDITS_SUCCESS";
export const DOCUMENT_EDITS_ERROR = "DOCUMENT_EDITS_ERROR";
export const DOCUMENT_EDIT_LOADING = "DOCUMENT_EDIT_LOADING";
export const DOCUMENT_EDIT_SUCCESS = "DOCUMENT_EDIT_SUCCESS";
export const DOCUMENT_EDIT_ERROR = "DOCUMENT_EDIT_ERROR";
export const DOCUMENT_EDIT_CREATE_LOADING = "DOCUMENT_EDIT_CREATE_LOADING";
export const DOCUMENT_EDIT_CREATE_SUCCESS = "DOCUMENT_EDIT_CREATE_SUCCESS";
export const DOCUMENT_EDIT_CREATE_ERROR = "DOCUMENT_EDIT_CREATE_ERROR";
export const DOCUMENT_EDIT_REVIEW_LOADING = "DOCUMENT_EDIT_REVIEW_LOADING";
export const DOCUMENT_EDIT_REVIEW_SUCCESS = "DOCUMENT_EDIT_REVIEW_SUCCESS";
export const DOCUMENT_EDIT_REVIEW_ERROR = "DOCUMENT_EDIT_REVIEW_ERROR";
export const DOCUMENT_EDIT_APPLY_LOADING = "DOCUMENT_EDIT_APPLY_LOADING";
export const DOCUMENT_EDIT_APPLY_SUCCESS = "DOCUMENT_EDIT_APPLY_SUCCESS";
export const DOCUMENT_EDIT_APPLY_ERROR = "DOCUMENT_EDIT_APPLY_ERROR";
export const DOCUMENT_EDIT_UNDO_LOADING = "DOCUMENT_EDIT_UNDO_LOADING";
export const DOCUMENT_EDIT_UNDO_SUCCESS = "DOCUMENT_EDIT_UNDO_SUCCESS";
export const DOCUMENT_EDIT_UNDO_ERROR = "DOCUMENT_EDIT_UNDO_ERROR";
export const DOCUMENT_EDIT_COMMENT_LOADING = "DOCUMENT_EDIT_COMMENT_LOADING";
export const DOCUMENT_EDIT_COMMENT_SUCCESS = "DOCUMENT_EDIT_COMMENT_SUCCESS";
export const DOCUMENT_EDIT_COMMENT_ERROR = "DOCUMENT_EDIT_COMMENT_ERROR";
export const DOCUMENT_EDIT_TAG_LOADING = "DOCUMENT_EDIT_TAG_LOADING";
export const DOCUMENT_EDIT_TAG_SUCCESS = "DOCUMENT_EDIT_TAG_SUCCESS";
export const DOCUMENT_EDIT_TAG_ERROR = "DOCUMENT_EDIT_TAG_ERROR";
